import { render, staticRenderFns } from "./ModalUploader.vue?vue&type=template&id=45f7d8a7"
import script from "./ModalUploader.vue?vue&type=script&lang=js"
export * from "./ModalUploader.vue?vue&type=script&lang=js"
import style0 from "./ModalUploader.vue?vue&type=style&index=0&id=45f7d8a7&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../Development/QC/qcheck-app/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports